import './AndOrSelect.scss';
import {_} from '../../Lang.class.js';

export class AndOrSelect {
    private root: HTMLDivElement;
    private selectedValue: string;
    private onChange: (v:string)=>void;

    constructor(root: HTMLDivElement, onChange: (v:string)=>void) {
        this.root = root;
        this.selectedValue = 'and';
        this.onChange = onChange;
        this.render();
        this.updateDescription();
        this.updateColors();
    }

    setValue(value: string) {
        this.selectedValue = value;
        this.render();
        this.updateDescription();
        this.updateColors();
    }

    render() {
        this.root.innerHTML = `
            <div class="js-and-or-container">
                <select class="and-or-select">
                  <option value="and">${_('wszystkie')}</option>
                  <option value="or">${_('dowolny')}</option>
                </select>
                <div class="js-description"></div>
            </div>
        `;
        let sel = this.root.querySelector('.and-or-select') as HTMLSelectElement;
        if (sel) {

            // set default value
            sel.value = this.selectedValue;

            // trigger change event
            let event = new Event('change');
            sel.dispatchEvent(event);

            sel.addEventListener('change', (e: Event)=>{
                console.log(e.target.value);
                this.selectedValue = e.target.value;
                this.updateDescription();
                this.updateColors();
                this.onChange(this.getCurrentValue());
            })
        }
    }

    updateColors() {
        let sel = this.root.querySelector('.and-or-select');
        if (sel) {
            if (this.selectedValue === 'and') {
                sel.classList.add('and');
                sel.classList.remove('or');
            } else {
                sel.classList.add('or');
                sel.classList.remove('and');
            }
        }
    }

    updateDescription() {
        let desc = this.root.querySelector('.js-description');
        if (desc) {
            switch (this.selectedValue) {
                case 'or': {
                    desc.innerHTML = _('condition_met')
                    break;
                }
                case 'and': {
                    desc.innerHTML = _('conditions_met');
                    break;
                }
            }
        }
    }

    getCurrentValue(): string {
        return this.selectedValue;
    }

}
